import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import 'assets/style/iconfont.css';
import 'assets/style/index.scss';
import Http from './utils/http.js';
import Api from './utils/api.js';
import sHttp from './utils/student_http';
import tHttp from './utils/teacher_http';
import FileHttp from './utils/file_http';
import Video from 'video.js'
import 'video.js/dist/video-js.css'
import Common from './utils/common.js';
import VueKindEditor from 'vue-kindeditor'
import 'kindeditor/kindeditor-all-min.js'
import 'kindeditor/themes/default/default.css'
import lockr from 'lockr';
import Config from '@/utils/wsConfig'
import "assets/style/myfont.css"
import "@wangeditor/editor/dist/css/style.css"
import elTableInfiniteScroll from 'el-table-infinite-scroll';

Vue.use(elTableInfiniteScroll);
Vue.config.productionTip = false
Vue.use(ElementUI);
Vue.use(VueKindEditor);
import echarts from "echarts";
Vue.prototype.$echarts = echarts;

Vue.prototype.$http = Http;
Vue.prototype.$api = Api;
Vue.prototype.$fileHttp = FileHttp;
Vue.prototype.$shttp = sHttp;
Vue.prototype.$video = Video;
Vue.prototype.$common = Common;
Vue.prototype.$lockr = lockr;
Vue.prototype.$thttp = tHttp;
Vue.prototype.$config = Config;

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
